module.exports = __webpack_public_path__ + "static/media/AR.1b145e05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AR.svg
// module id = 2100
// module chunks = 7